import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { MDBBtn, MDBContainer, MDBIcon, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import React, { useEffect, useRef } from 'react';
const payData = [
  {
    month: 'January',
    payPeriod: '1/01/2024 - 1/30/2024',
    paymentDate: '1/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 2000,
      socialSecurity: 124,
      medicare: 29,
      netPay: 1847,
    },
  },
  {
    month: 'February',
    payPeriod: '2/01/2024 - 2/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    paymentDate: '2/30/2024',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 4000,
      socialSecurity: 248,
      medicare: 58,
      netPay: 3694,
    }
  },
  {
    month: 'March',
    payPeriod: '3/01/2024 - 3/30/2024',
    paymentDate: '3/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 6000,
      socialSecurity: 372,
      medicare: 87,
      netPay: 5541,
    },
  },
  {
    month: 'April',
    payPeriod: '4/01/2024 - 4/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    paymentDate: '4/30/2024',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 8000,
      socialSecurity: 496,
      medicare: 116,
      netPay: 7388,
    },
  },
  {
    month: 'May',
    payPeriod: '5/01/2024 - 5/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    paymentDate: '5/30/2024',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 10000,
      socialSecurity: 620,
      medicare: 145,
      netPay: 9235,
    },
  },
  {
    month: 'June',
    payPeriod: '6/01/2024 - 6/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    paymentDate: '6/30/2024',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 12000,
      socialSecurity: 744,
      medicare: 174,
      netPay: 11082,
    },
  },
  {
    month: 'July',
    payPeriod: '7/01/2024 - 7/30/2024',
    paymentDate: '7/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 14000,
      socialSecurity: 868,
      medicare: 203,
      netPay: 12929,
    },
  },
  {
    month: 'August',
    payPeriod: '8/01/2024 - 8/30/2024',
    paymentDate: '8/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 16000,
      socialSecurity: 992,
      medicare: 232,
      netPay: 14776,
    },
  },
  {
    month: 'September',
    payPeriod: '9/01/2024 - 9/30/2024',
    paymentDate: '9/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 18000,
      socialSecurity: 1116,
      medicare: 261,
      netPay: 16623,
    },
  },
  {
    month: 'October',
    payPeriod: '10/01/2024 - 10/30/2024',
    paymentDate: '10/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 20000,
      socialSecurity: 1240,
      medicare: 290,
      netPay: 18470,
    },
  },
  {
    month: 'November',
    payPeriod: '11/01/2024 - 11/30/2024',
    paymentDate: '11/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 22000,
      socialSecurity: 1364,
      medicare: 319,
      netPay: 20317,
    },
  },
  {
    month: 'December',
    payPeriod: '12/01/2024 - 12/30/2024',
    paymentDate: '12/30/2024',
    employee: 'Aryan Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 2000,
    socialSecurity: 124,
    medicare: 29,
    netPay: 1847,
    yearToDate: {
      grossPay: 24000,
      socialSecurity: 1488,
      medicare: 348,
      netPay: 22164,
    },
  },
  {
    month: 'January',
    payPeriod: '1/01/2024 - 1/30/2024',
    paymentDate: '1/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 1200,
      socialSecurity: 74.4,
      medicare: 17.4,
      netPay: 1108.2,
    },
  },
  {
    month: 'February',
    payPeriod: '2/01/2024 - 2/30/2024',
    paymentDate: '2/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 2400,
      socialSecurity: 148.8,
      medicare: 34.8,
      netPay: 2216.4,
    },
  },
  {
    month: 'March',
    payPeriod: '3/01/2024 - 3/30/2024',
    paymentDate: '3/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 3600,
      socialSecurity: 223.2,
      medicare: 52.2,
      netPay: 3324.6,
    },
  },
  {
    month: 'April',
    payPeriod: '4/01/2024 - 4/30/2024',
    paymentDate: '4/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 4800,
      socialSecurity: 297.6,
      medicare: 69.6,
      netPay: 4432.8,
    },
  },
  {
    month: 'May',
    payPeriod: '5/01/2024 - 5/30/2024',
    paymentDate: '5/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 6000,
      socialSecurity: 372,
      medicare: 87,
      netPay: 5541,
    },
  },
  {
    month: 'June',
    payPeriod: '6/01/2024 - 6/30/2024',
    paymentDate: '6/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 7200,
      socialSecurity: 446.4,
      medicare: 104.4,
      netPay: 6649.2,
    },
  },
  {
    month: 'July',
    payPeriod: '7/01/2024 - 7/30/2024',
    paymentDate: '7/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 8400,
      socialSecurity: 520.8,
      medicare: 121.8,
      netPay: 7757.4,
    },
  },
  {
    month: 'August',
    payPeriod: '8/01/2024 - 8/30/2024',
    paymentDate: '8/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 9600,
      socialSecurity: 595.2,
      medicare: 139.2,
      netPay: 8865.6,
    },
  },
  {
    month: 'September',
    payPeriod: '9/01/2024 - 9/30/2024',
    paymentDate: '9/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 10800,
      socialSecurity: 669.6,
      medicare: 156.6,
      netPay: 9973.8,
    },
  },
  {
    month: 'October',
    payPeriod: '10/01/2024 - 10/30/2024',
    paymentDate: '10/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 12000,
      socialSecurity: 744,
      medicare: 174,
      netPay: 11082,
    },
  },
  {
    month: 'November',
    payPeriod: '11/01/2024 - 11/30/2024',
    paymentDate: '11/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 13200,
      socialSecurity: 818.4,
      medicare: 191.4,
      netPay: 12190.2,
    },
  },
  {
    month: 'December',
    payPeriod: '12/01/2024 - 12/30/2024',
    paymentDate: '12/30/2024',
    employee: 'Sahasra Chalicham',
    employer: 'Chalicham Technologies Inc.',
    ein: '87-1905948',
    grossPay: 1200,
    socialSecurity: 74.4,
    medicare: 17.4,
    netPay: 1108.2,
    yearToDate: {
      grossPay: 14400,
      socialSecurity: 892.8,
      medicare: 208.8,
      netPay: 13298.4,
    },
  }



];


const generatePDF1 = (data) => {
  const doc = new jsPDF();

  // Add content to the PDF
  doc.setFontSize(18);
  doc.text('Pay Stub', 10, 10);

  doc.setFontSize(12);
  doc.text(`Pay Period: ${data.payPeriod}`, 10, 20);
  doc.text(`Payment Date: ${data.paymentDate}`, 10, 30);
  doc.text(`Employer: ${data.employer}`, 10, 40);
  doc.text(`Employee: ${data.employee}`, 10, 50);

  doc.text(`Gross Pay: $${data.grossPay.toFixed(2)}`, 10, 60);
  doc.text(`Social Security (6.2%): $${data.socialSecurity.toFixed(2)}`, 10, 70);
  doc.text(`Medicare (1.45%): $${data.medicare.toFixed(2)}`, 10, 80);
  doc.text(`Net Pay: $${data.netPay.toFixed(2)}`, 10, 90);

  doc.text('Year-to-Date Totals:', 10, 100);
  doc.text(`Gross Pay: $${data.yearToDate.grossPay.toFixed(2)}`, 10, 110);
  doc.text(`Social Security: $${data.yearToDate.socialSecurity.toFixed(2)}`, 10, 120);
  doc.text(`Medicare: $${data.yearToDate.medicare.toFixed(2)}`, 10, 130);
  doc.text(`Net Pay: $${data.yearToDate.netPay.toFixed(2)}`, 10, 140);

  // Save the PDF
  doc.save(`${data.month}_PayStub.pdf`);
};




export default function PayStub() {

  // const rowRefs = useRef([]);

  // // Ensure refs array has the same length as the data
  // useEffect(() => {
  //   rowRefs.current = rowRefs.current.slice(0, payData.length);
  // }, [payData]);

  // const generatePDF = async (index) => {
  //   const element = rowRefs.current[index];
  //   if (!element) {
  //     console.error(`Element not found for index: ${index}`);
  //     return;
  //   }

  //   try {
  //     const canvas = await html2canvas(element, { scale: 2 });
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF();

  //     pdf.addImage(imgData, 'PNG', 10, 10, 190, 0); // Fit the image to the page width
  //     pdf.save(`${payData[index].month}_PayStub.pdf`);
  //   } catch (error) {
  //     console.error('Error generating PDF:', error);
  //   }
  // };


  const rowRefs = useRef([]);

  useEffect(() => {
    rowRefs.current = rowRefs.current.slice(0, payData.length);
  }, [payData]);

  const generatePDF = async (index) => {
    const element = rowRefs.current[index];
    if (!element) {
      console.error(`Element not found for index: ${index}`);
      return;
    }

    try {
      // Capture element as an image
      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL('image/png');

      // Create PDF with custom dimensions for a pay stub (3x8 inches)
      const pdf = new jsPDF({
        orientation: 'landscape', // Landscape orientation for pay stub
        unit: 'in', // Use inches for dimensions
        format: [3, 8], // Dimensions: 3 inches height, 8 inches width
      });

      // Add image to PDF, scaled to fit the page
      pdf.addImage(imgData, 'PNG', 0, 0, 8, 3);

      // Save the PDF
      pdf.save(`${payData[index].month}_PayStub.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };


  return (
    <MDBContainer>
      <MDBTable bordered align="middle">
        <MDBTableHead className="text-center">
          <tr>
            <th scope="col">Month</th>
            <th scope="col">Pay Stub</th>
            <th scope="col">Actions</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {payData.map((data, index) => (
            <tr key={index}>
              <td className="text-center">{data.month}</td>
              <td>
                <div ref={(el) => (rowRefs.current[index] = el)}>
                  <MDBTable bordered align="middle">
                    <MDBTableBody>
                      <tr className="text-end">
                        <td colSpan="2">
                          <strong>Pay Period:</strong> {data.payPeriod}
                          <br />
                          <strong>Payment Date:</strong> {data.paymentDate}
                          
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2">
                          <strong>Employer:</strong> {data.employer}<br />                        
                          <strong>Employer EIN:</strong> {data.ein}  <br />
                          <strong>Employee Name:</strong> {data.employee}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Gross Pay:</strong> ${data.grossPay.toFixed(2)}
                          <br />
                          <strong>Deductions:</strong>
                          <ul>
                            <li>Social Security (6.2%): ${data.socialSecurity.toFixed(2)}</li>
                            <li>Medicare (1.45%): ${data.medicare.toFixed(2)}</li>
                          </ul>
                        </td>
                        <td>
                          <strong>Net Pay:</strong> ${data.netPay.toFixed(2)}
                          <br />
                          <strong>Year-to-Date Totals:</strong>
                          <ul>
                            <li>Gross Pay: ${data.yearToDate.grossPay.toFixed(2)}</li>
                            <li>Social Security: ${data.yearToDate.socialSecurity.toFixed(2)}</li>
                            <li>Medicare: ${data.yearToDate.medicare.toFixed(2)}</li>
                            <li>Net Pay: ${data.yearToDate.netPay.toFixed(2)}</li>
                          </ul>
                        </td>
                      </tr>
                    </MDBTableBody>
                  </MDBTable>
                </div>
              </td>
              <td className="text-center">
                {/* <button onClick={() => generatePDF(index)}>Print PDF</button> */}
                <MDBBtn floating tag='a' onClick={() => generatePDF(index)}>
                  <MDBIcon fas icon='download' />
                </MDBBtn>
              </td>
            </tr>
          ))}
        </MDBTableBody>
      </MDBTable>
    </MDBContainer>
  );
}
